import { ClipboardCopy } from 'lucide-react';
import { IconButton } from '@wundo/ui';

export function CopyButton({ value, label }: { value: string; label: string }) {
  return (
    <IconButton
      size='sm'
      aria-label={label}
      onClick={() => void navigator.clipboard.writeText(value)}
    >
      <ClipboardCopy className='size-3.5' aria-hidden='true' />
    </IconButton>
  );
}
